import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomButton from "components/Button";
import { FaPlus } from "react-icons/fa6";
import AddUser from "./AddUser";
import AllUsers from "./AllUsers";
import { useLazyGetUserListQuery } from "store/slices/apis/userApiSlice";
import { useParams } from "react-router-dom";
import TrackerPageHeader from "components/TrackerPageHeader";

function UserList() {
    const { projectId } = useParams();
    const [isAddUser, setIsAddUser] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const handleAddUser = () => setIsAddUser(true);
    const handleCloseAddUser = () => setIsAddUser(false);
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    searchQuery: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    // const { data: userDataList, error, isLoading, isFetching, refetch } = useGetUserListQuery({
    //     pageNumber: 1,
    //     pageSize: 50,
    //     ...(projectId ? { projectId } : {}),
    // });

    // const tableData = userDataList?.data?.users ?? [];
    // const allCount = tableData?.length;
    // const addedCount = tableData?.filter((item) => item.status === "In Progress").length;
    // const inactiveCount = tableData?.filter((item) => item.status === "Inactive").length;

    const [filters, setFilters] = useState({
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        ...(projectId ? { projectId: projectId } : {}),
    });


    const [trigger, { data: userData, isLoading: isloading, isFetching, }] = useLazyGetUserListQuery();
    const tableData = userData?.data?.users ?? [];

    useEffect(() => {
        trigger(filters);
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
    };

    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setPageNumber(1);
        handleClose();

    };

    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const createSortHandler = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };



    // const tabCounts = [allCount, addedCount, inactiveCount];

    // const getFilteredData = () => {
    //     if (value === 1) {
    //         return tableData.filter((item) => item.status === "In Progress");
    //     }
    //     if (value === 2) {
    //         return tableData.filter((item) => item.status === "Inactive");
    //     }
    //     return tableData;
    // };

    // const filteredData = getFilteredData();


    return (
        <>
            <TrackerPageHeader title="Users" description="Manage user accounts, access, and project assignments.">
                <CustomButton label="Create User" startIcon={<FaPlus />} color="primary" onClick={handleAddUser} sx={{ backgroundColor: "#2563EB", fontFamily: "Outfit", fontWeight: 500, fontSize: "14px" }} />
            </TrackerPageHeader>
        <Grid container spacing={0} >
            <Grid size={12} sx={{
                p: 2,
                backgroundColor: "#FFFFFF",
                minHeight: "100vh",
            }}>
                <AllUsers
                    data={tableData}
                    loading={isloading}
                    isFetching={isFetching}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                    pageNumber={pageNumber}
                    filters={filters}
                    createSortHandler={createSortHandler}
                    setFilters={setFilters}
                    handleClose={handleClose}
                    handleDelete={handleDelete}
                    handleReset={handleReset}
                    handleApplyFilters={handleApplyFilters}
                    handleSelectChange={handleSelectChange}
                    setOpen={setOpen}
                    mappedUser={Boolean(projectId)}
                    open={open}
                    order={sortOrder}
                    orderBy={sortBy}
                    pageSize={pageSize}
                    currentPage={pageNumber}
                    totalCount={userData?.data?.totalCount ?? 0}
                    setCurrentPage={setPageNumber}
                    setSearchTerm={setSearchTerm}
                    searchTerm={searchTerm}
                    trigger={trigger}
                />
            </Grid>
            {isAddUser &&
                <AddUser open={isAddUser} handleClose={handleCloseAddUser} />
            }
        </Grid>
        </>
    );
}

export default UserList;
